import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #e6ecf1;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  background: #fbfdff;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #1a1a1a;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ActionButton = styled.button`
  border: 1px solid #d1dbe5;
  background: #ffffff;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  color: #1a1a1a;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #525252;
`;

export const Divider = styled.div`
  border-top: 1px solid #e6ecf1;
  margin: 16px 0;
`;
